export const iconFontAwesomeArrowsArrowDownUpAcrossLine = (
	<i className="fa-solid fa-arrow-down-up-across-line"></i>
);
